
import { Component, Vue } from 'vue-property-decorator';
import { namespace } from "vuex-class";

import "@/store/modules/information";
const informationState = namespace("Information");

import "@/store/modules/forms/form1";
const form1State = namespace("Form1");

import FillForm1HeaderInfo from "@/components/process/Form1/components/fillForm1/FillForm1HeaderInfo.vue";
import { locationsInfoType } from '@/types/Common';
import { form1StatesInfoType, form1DataInfoType } from '@/types/Information/Form1';

@Component({
    components:{
        FillForm1HeaderInfo
    }
})
export default class FillForm1SummaryInfo extends Vue {    

    @informationState.State
    public caseLocation: locationsInfoType;

    @form1State.State
    public form1InfoStates: form1StatesInfoType;

    @form1State.State
    public form1Info: form1DataInfoType;

    @form1State.Action
    public UpdateForm1Info!: (newForm1Info: form1DataInfoType) => void

    levelOfCourt = "Supreme Court of BC";  
    judgeFullName = "";
    trialDurationDays = "";
    cityOfOrder = "";
    dataReady = false;

    mounted() { 
        this.dataReady = false; 
        this.judgeFullName = 
            this.form1Info.honorificTitle + ' ' + 
            this.form1Info.nameOfJudge;
        this.trialDurationDays = this.form1Info.trialDurationDays?this.form1Info.trialDurationDays:'';
        this.cityOfOrder = this.form1Info.cityOfOrder?this.form1Info.cityOfOrder:'';
        this.update();
        this.dataReady = true;            
    }

    public displayResults(){
        this.$emit('displayResults');
    }

    public update(){ 
              
        const form1 = this.form1Info;
        form1.trialDurationDays = this.trialDurationDays;     
        form1.cityOfOrder = this.cityOfOrder;
        form1.judgeFullName = this.judgeFullName;
        this.UpdateForm1Info(form1);
    }
    
    public recheckStates(){
        this.$emit('recheckStates')
    } 

}
